document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-navigation]');
  if (toggle && navigation) {
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      navigation.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      navigation.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
    navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
  }

  const passwordToggle = document.querySelector('[data-password-toggle]');
  const passwordPanel = document.getElementById('StorePassword');
  if (passwordToggle && passwordPanel) {
    passwordToggle.addEventListener('click', () => {
      const open = passwordToggle.getAttribute('aria-expanded') === 'true';
      passwordToggle.setAttribute('aria-expanded', String(!open));
      passwordPanel.hidden = open;
      if (!open) passwordPanel.querySelector('input')?.focus();
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const price = select.closest('[data-product-form]')?.parentElement?.querySelector('[data-product-price]');
      const option = select.options[select.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  });


  /* Give Shopify-hosted policy pages clear, premium visual sections without changing policy text. */
  /* Apply the approved Super3Met color identity to visible brand-name text across the storefront. */
  const brandPattern = /Super3Met/g;
  const excludedBrandParents = new Set(['SCRIPT','STYLE','TEXTAREA','INPUT','SELECT','OPTION','NOSCRIPT']);
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const brandNodes = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    const parent = node.parentElement;
    if (!parent || excludedBrandParents.has(parent.tagName) || parent.closest('.super3met-wordmark,.zt-super3met')) continue;
    if (brandPattern.test(node.nodeValue || '')) brandNodes.push(node);
    brandPattern.lastIndex = 0;
  }
  brandNodes.forEach((node) => {
    const pieces = (node.nodeValue || '').split('Super3Met');
    const fragment = document.createDocumentFragment();
    pieces.forEach((piece, index) => {
      if (piece) fragment.appendChild(document.createTextNode(piece));
      if (index < pieces.length - 1) {
        const brand = document.createElement('span');
        brand.className = 'zt-super3met';
        brand.setAttribute('aria-label', 'Super3Met');
        brand.innerHTML = '<span class="zt-super">Super</span><span class="zt-three">3</span><span class="zt-met">Met</span>';
        fragment.appendChild(brand);
      }
    });
    node.replaceWith(fragment);
  });

  const policyBody = document.querySelector('.shopify-policy__body');
  if (policyBody) {
    const policyRoot = policyBody.querySelector(':scope > .rte') || policyBody;
    if (!policyRoot.dataset.ztPolicySections) {
      const children = Array.from(policyRoot.children);
      const headingTag = children.some((el) => el.tagName === 'H2')
        ? 'H2'
        : (children.some((el) => el.tagName === 'H3') ? 'H3' : null);

      if (headingTag) {
        const fragment = document.createDocumentFragment();
        let currentSection = null;
        let intro = null;
        let toneIndex = 0;

        children.forEach((element) => {
          if (element.tagName === headingTag) {
            currentSection = document.createElement('section');
            currentSection.className = `zt-policy-section zt-policy-tone-${toneIndex % 4}`;
            toneIndex += 1;
            currentSection.appendChild(element);
            fragment.appendChild(currentSection);
          } else if (currentSection) {
            currentSection.appendChild(element);
          } else {
            if (!intro) {
              intro = document.createElement('div');
              intro.className = 'zt-policy-intro';
              fragment.appendChild(intro);
            }
            intro.appendChild(element);
          }
        });

        policyRoot.replaceChildren(fragment);
      }
      policyRoot.dataset.ztPolicySections = 'true';
    }
  }
});
